import Layout from "../../components/layout";
import Seo from "../../components/seo";
import { SideNav } from "../../components/side-nav";
import { useRouter } from "next/router";
import { Product } from "../../components/product";
import { CategoryHero } from "../../components/category-hero";
import { CategoryCard } from "../../components/category-card";
import { Breadcrumbs } from "../../components/breadcrumbs";
import {
  _getStaticProps,
  _getStaticPaths,
  category_getStaticProps,
  collection_getStaticPaths,
} from "../../lib/statics";
import { useEffect, useMemo } from "react";

const Category = ({ category, categories }) => {
  const router = useRouter();
  const slugs = useMemo(() => router.query.slug || [], [router.query.slug]);

  category?.attributes?.children?.data.sort((a, b) => {
    return (
      (a?.attributes?.order === null) - (b?.attributes?.order === null) ||
      +(a?.attributes?.order > b?.attributes?.order) ||
      -(a?.attributes?.order < b?.attributes?.order)
    );
  });

  const seo = {
    metaTitle: category?.attributes?.name,
    metaDescription: `All ${category?.attributes?.name} products`,
  };

  return (
    <Layout categories={categories}>
      <Seo seo={seo} />
      <div className={`hidden lg:block border-t border-b pt-2 pb-2 bg-white`}>
        <div className="container mx-auto pl-1 pr-1">
          <Breadcrumbs
            category={category}
            categories={categories}
            slugs={slugs}
          />
        </div>
      </div>
      <div className={`bg-[#F5F5F5] py-8`}>
        <div className="container mx-auto pl-1 pr-1">
          <div className={`grid lg:grid-cols-5 gap-8`}>
            <div className={`hidden lg:block`}>
              <SideNav category={category} categories={categories} />
            </div>
            <main className={`col-span-4`}>
              <h1
                className={`font-display font-bold text-[40px] uppercase leading-none`}
              >
                {category?.attributes?.name}
              </h1>

              {category?.attributes?.description && (
                <p className={`mt-4`}>{category?.attributes?.description}</p>
              )}

              {category?.attributes?.children?.data?.length > 0 && (
                <>
                  <CategoryHero
                    category={category.attributes.children?.data[0]}
                    slugs={slugs}
                  />
                  <section className={`grid lg:grid-cols-3 gap-8 my-4`}>
                    {category.attributes.children?.data
                      ?.slice(1, category.attributes.children?.data.length)

                      .map((child, key) => {
                        return (
                          <CategoryCard
                            category={child}
                            slugs={slugs}
                            key={key}
                          />
                        );
                      })}
                  </section>
                </>
              )}
              {category?.attributes?.products?.data?.length > 0 && (
                <section className={`grid my-4`}>
                  {category?.attributes?.products?.data
                    .sort((a, b) => {
                      return (
                        (a.attributes.order === null) -
                          (b.attributes.order === null) ||
                        +(a.attributes.order > b.attributes.order) ||
                        -(a.attributes.order < b.attributes.order)
                      );
                    })
                    .map((product, key) => {
                      return <Product key={key} product={product} />;
                    })}
                </section>
              )}
            </main>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export async function getStaticProps({ params }) {
  return category_getStaticProps({ params });
}

export async function getStaticPaths() {
  return collection_getStaticPaths("categories");
}

export default Category;
